import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    butonNavegation: {
      width: 100,
      display: 'flex',
      alignItems: 'center',
      margin: '-4.063rem 0px 1.25rem -4px',
      position: 'relative',
      zIndex: 1298,
    },
    customMargin: {
      margin: '-5rem 0px 1.25rem -4px',
    },
  }),
);

export default useStyles;
